export default {
    SET_AIRPORT_LIST(state, list) {
        state.airport_list = list
    },
    SET_AVAIBLES(state, list) {
        state.avaibles = list
    },
    SET_AVAIBLE_15_DAYS(state, list) {
        state.avaible_15_days = list
    },
    SET_SELECTED_SOURCE(state, list) {
        state.selectedSource = list
    },
    SET_SELECTED_DESTINATION(state, list) {
        state.selectedDestination = list
    },
    SET_SELECTED_TICKET(state, list) {
        state.selectedTicket = list
    },
    SET_TICKET_USER_INFO (state , info ){
        state.ticket_user_info = info
    },
    SET_CAPTCHA (state , info ){
        state.captcha = info
    },
    SET_PASSENGERS_COUNT(state,count){
        state.passengers_count = count
    }
}
